const getEstimatedArrivalDate = (currentDate, numDays, bufferDays = 0) => {
  let totalDeliveryDays = numDays;
  // convert the date obj to EST date/time zone since the cutoff is based on EST
  const currentDateInEST = new Date(
    currentDate.toLocaleString('en-US', {
      timeZone: 'America/New_York',
    }),
  );

  if (currentDateInEST.getDay() === 0 || currentDateInEST.getDay() === 6) {
    totalDeliveryDays += bufferDays;
  }
  currentDateInEST.setDate(currentDateInEST.getDate() - 1);
  while (totalDeliveryDays > 0) {
    // Check if the current day is not a weekend (Saturday or Sunday)
    currentDateInEST.setDate(currentDateInEST.getDate() + 1);
    if (currentDateInEST.getDay() !== 0 && currentDateInEST.getDay() !== 6) {
      totalDeliveryDays--;
    }
  }
  return currentDateInEST;
};

const getBadgingDetails = (eventData, deliveryDays, isBoss, categoryId, pickupMsg = null, userDate = new Date()) => {
  const campaignStartDate = new Date(eventData.startTime);
  const campaignCutoffDate = new Date(eventData.endTime);

  if (isBoss) {
    const onlyBossConfig = eventData.eventAttributes.filter((event) => event.orderType === 'BOSS');
    const bossEventData = { ...eventData, eventAttributes: onlyBossConfig };
    if (bossEventData.eventAttributes.length) {
      if (bossEventData.categoryIds && bossEventData.categoryIds.length) {
        if (!bossEventData.categoryIds.includes(categoryId)) return false;
      }

      const cutOffForBoss = new Date(bossEventData.eventAttributes[0].cutOffTime);
      const isOtherStartTime = bossEventData.eventAttributes[0].startTime ? new Date(bossEventData.eventAttributes[0].startTime) : null;

      if (userDate >= campaignStartDate && userDate <= campaignCutoffDate) {
        const bufferDays = bossEventData.eventAttributes[0].bufferDays || 0;
        const bossArrivalDate = getEstimatedArrivalDate(userDate, deliveryDays.bossDeliveryDays,
          Number(bufferDays));
        const showBossMessage = isOtherStartTime ? userDate >= isOtherStartTime && bossArrivalDate <= campaignCutoffDate
                && userDate <= cutOffForBoss : bossArrivalDate <= campaignCutoffDate && userDate <= cutOffForBoss;

        if (showBossMessage) return { message: bossEventData.eventAttributes[0].message, color: bossEventData.badgingColor };
      }
    }
  } else {
    const isToday = pickupMsg.includes('today');
    const onlyBopsConfig = eventData.eventAttributes.filter((event) => event.orderType === 'BOPS');
    const bopsEventData = { ...eventData, eventAttributes: onlyBopsConfig };
    if (bopsEventData.eventAttributes.length) {
      if (bopsEventData.categoryIds && bopsEventData.categoryIds.length) {
        if (!bopsEventData.categoryIds.includes(categoryId)) return false;
      }

      const cutOffForBops = new Date(bopsEventData.eventAttributes[0].cutOffTime);
      const isOtherStartTime = bopsEventData.eventAttributes[0].startTime ? new Date(bopsEventData.eventAttributes[0].startTime) : null;

      if (userDate >= campaignStartDate && userDate <= campaignCutoffDate) {
        if (userDate >= isOtherStartTime && userDate.getDate() === cutOffForBops.getDate() && isToday) {
          return { message: bopsEventData.eventAttributes[0].message, color: bopsEventData.badgingColor };
        } if (userDate >= isOtherStartTime && userDate.getDate() < cutOffForBops.getDate()) {
          if (eventData.division.toLowerCase() === 'mcom') {
            if (!isToday) return { message: bopsEventData.eventAttributes[0].message, color: bopsEventData.badgingColor };
          } else {
            return { message: bopsEventData.eventAttributes[0].message, color: bopsEventData.badgingColor };
          }
        }
      }
    }
  }
  return false;
};
export default getBadgingDetails;
